import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useFormalExaminationService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetFormalExamination, setFetchingGetFormalExamination] = useState(false);
    const [fetchingCreateFormalExamination, setFetchingCreateFormalExamination] = useState(false);
    const [fetchingGetInapiApplicationId, setFetchingGetInapiApplicationId] = useState(false);
    const [fetchingGetInapiAutofillData, setFetchingGetInapiAutofillData] = useState(false);
    
    const BASE_PATH = 'brand-registrations/formal-examination';
    
    /**
     * Obtener inapi_application_id a partir del brand_registration_id
     */
    const getInapiApplicationId = (brandRegistrationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brandRegistrationId}/inapi-application-id`),
            setFetching: setFetchingGetInapiApplicationId
        });
    };
    
    /**
     * Obtener examen de forma por ID de solicitud INAPI
     */
    const getFormalExamination = (inapiApplicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${inapiApplicationId}/show`),
            setFetching: setFetchingGetFormalExamination
        });
    };
    
    /**
     * Obtener datos de INAPI para autocompletar el formulario
     */
    const getInapiAutofillData = (inapiApplicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${inapiApplicationId}/inapi-autofill`),
            setFetching: setFetchingGetInapiAutofillData
        });
    };
    
    /**
     * Crear o actualizar examen de forma
     */
    const createFormalExamination = (data: any, events: ServiceEvents = {}) => {
        const inapiApplicationId = data.inapi_application_id;
        const url = inapiApplicationId 
            ? buildEndpoint(`${BASE_PATH}/create?inapi_application_id=${inapiApplicationId}`)
            : buildEndpoint(`${BASE_PATH}/create`);
            
        doPost({
            ...events,
            url: url,
            body: data,
            setFetching: setFetchingCreateFormalExamination
        });
    };
    
    return {
        getInapiApplicationId,
        getFormalExamination,
        getInapiAutofillData,
        createFormalExamination,
        fetchingGetInapiApplicationId,
        fetchingGetFormalExamination,
        fetchingGetInapiAutofillData,
        fetchingCreateFormalExamination
    };
};

export default useFormalExaminationService;

